import React, { use } from 'react';
import Layout from '../../components/Layout';
import { Card, Row, Col, ProgressBar } from 'react-bootstrap';
import { MdManageAccounts,MdHolidayVillage } from "react-icons/md";
import { FaUsers,FaTasks,FaRoute } from "react-icons/fa";
import { TbReportAnalytics } from "react-icons/tb";
import { useNavigate } from 'react-router-dom';
import { IoDocumentTextOutline } from 'react-icons/io5';

const Dashboard = () => {

  const navigate = useNavigate();
  const handleCardClick = (path) => {
    navigate(path);
  }
  const user = JSON.parse(localStorage.getItem("user"));
 
  return (
    <Layout>
      <h3 className="mb-4">Dashboard</h3>

      <Row className="mb-4">
        
       {user.role !== "employee" &&
       <>
       <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/contractor/profile')}>
            <Card.Body className='p-4'>
              <Card.Title className="text-primary">Manage Account</Card.Title>
              <div className="d-flex justify-content-center align-items-center">
                <MdManageAccounts size={70} className="text-primary" />
                </div>
            </Card.Body>
          </Card>
        </Col>
       <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/employees')}>
            <Card.Body className='p-4'>
              <Card.Title className="text-success">Manage Employee</Card.Title>
               <div className="d-flex justify-content-center align-items-center">
                <FaUsers size={70} className="text-success" />
                </div>
            </Card.Body>
          </Card>
        </Col>
         <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/employeetasks')}>
            <Card.Body className='p-4'>
              <Card.Title className="text-primary">Daily Task Approval</Card.Title>
               <div className="d-flex justify-content-center align-items-center">
                <FaTasks size={70} className="text-primary" />
                </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/payslip')}>
            <Card.Body className='p-4'>
              <Card.Title className="text-success">Manage Salary Slip</Card.Title>
               <div className="d-flex justify-content-center align-items-center">
                <IoDocumentTextOutline size={70} className="text-success" />
                </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/reports')}> 
            <Card.Body className='p-4'>
              <Card.Title className="text-primary">Reports</Card.Title>
               <div className="d-flex justify-content-center align-items-center">
                <TbReportAnalytics size={70} className="text-primary" />
                </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/holidays')}>
            <Card.Body className='p-4'>
              <Card.Title className="text-success">Holidays</Card.Title>
               <div className="d-flex justify-content-center align-items-center">
                <MdHolidayVillage size={70} className="text-success" />
                </div>
            </Card.Body>
          </Card>
        </Col>
        </>}
        {user.role === "employee" &&
        <>
        <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/employee/profile')}>
            <Card.Body className='p-4'>
              <Card.Title className="text-primary">Manage Account</Card.Title>
              <div className="d-flex justify-content-center align-items-center">
                <MdManageAccounts size={70} className="text-primary" />
                </div>
            </Card.Body>
          </Card>
        </Col>
         <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/mytask')}>
            <Card.Body className='p-4'>
              <Card.Title className="text-success">My Task</Card.Title>
               <div className="d-flex justify-content-center align-items-center">
                <FaTasks size={70} className="text-success" />
                </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/taskhistory')}>
            <Card.Body className='p-4'>
              <Card.Title className="text-primary">Task History</Card.Title>
               <div className="d-flex justify-content-center align-items-center">
                <IoDocumentTextOutline size={70} className="text-primary" />
                </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/invoice')}> 
            <Card.Body className='p-4'>
              <Card.Title className="text-success">Invoice</Card.Title>
               <div className="d-flex justify-content-center align-items-center">
                <TbReportAnalytics size={70} className="text-success" />
                </div>
            </Card.Body>
          </Card>
        </Col>
        <Col md={3} sm={6} className="mb-3">
          <Card className="shadow-sm d-flex justify-content-center align-items-center" style={{cursor:"pointer"}} onClick={() => handleCardClick('/holidays')}>
            <Card.Body className='p-4'>
              <Card.Title className="text-primary">Holidays</Card.Title>
               <div className="d-flex justify-content-center align-items-center">
                <MdHolidayVillage size={70} className="text-primary" />
                </div>
            </Card.Body>
          </Card>
        </Col>
        </>}
      </Row>
    </Layout>
  );
};

export default Dashboard;